import { Link } from 'react-router-dom';
import { Sparklines, SparklinesLine, SparklinesBars, SparklinesReferenceLine } from 'react-sparklines';
import { useProxyStatus } from '../state';

export default function ProxyStatus() {
  const { loading, status } = useProxyStatus();

  const cellStyle = {
    border: '1px solid #ccc',
    padding: '2px 4px',
    fontFamily: 'monospace',
    fontSize: 12,
  };

  const stickyStyle = {
    position: 'sticky',
    top: -1,
    background: 'white',
    zIndex: 2,
  };

  const sl = (data) => (
    <Sparklines
      data={data}
      width={80}
      height={24}
      margin={0}
      min={Math.min(...data)*.6}
      max={Math.max(...data)*1.1}
      >
      <SparklinesBars />
      <SparklinesReferenceLine type="mean" />
    </Sparklines>
  );

  const percentile = (nums, p) => {
    nums = nums.slice().sort((a, b) => a - b);
    const i = (p / 100) * (nums.length - 1);
    const lo = Math.floor(i), hi = Math.ceil(i);
    const x = (lo == hi ? nums[lo] : nums[lo] + (nums[hi] - nums[lo]) * (i - lo));
    return x && x.toFixed(2);
  };

  const rows = (status || [])
    .sort((a, b) => {
      if (a.cutoff != b.cutoff) {
        return a.cutoff - b.cutoff;
      }
      const k = (it) => it.name + ':' + it.key;
      return k(a).localeCompare(k(b));
    })
    .map((it, idx) => {
      const seconds = it.stats?.points?.seconds || [];
      const bytes = (it.stats?.points?.bytes || []).map(it => it / 1000);

      const avg = it.stats.avg.seconds;
      const [p10, p50, p90] = [
        percentile(seconds, 10),
        percentile(seconds, 50),
        percentile(seconds, 90),
      ];
      const colorFn = p => 0.5 * (p - avg) / avg;
      const [
        p10color,
        p50color,
        p90color,
      ] = [
        `rgba(255,0,0,${colorFn(p10)}`,
        `rgba(255,0,0,${colorFn(p50)})`,
        `rgba(255,0,0,${colorFn(p90)})`,
      ];

      const avgB = it.stats.avg.bytes / 1000;
      const [p10b, p50b, p90b] = [
        percentile(bytes, 10),
        percentile(bytes, 50),
        percentile(bytes, 90),
      ];
      const colorFnB = p => -0.5 * (p - avgB) / avgB;
      const [
        p10bcolor,
        p50bcolor,
        p90bcolor,
      ] = [
        `rgba(255,0,0,${colorFnB(p10b)}`,
        `rgba(255,0,0,${colorFnB(p50b)})`,
        `rgba(255,0,0,${colorFnB(p90b)})`,
      ];

      return (
        <tr key={idx}>
          <td style={cellStyle}>{it.key}</td>
          <td style={{ ...cellStyle, textAlign: 'right' }}>
            {it.name}
          </td>

          <td style={{ ...cellStyle, width: 80, padding: 0 }}>
            {sl(seconds)}
          </td>
          <td style={{ ...cellStyle, textAlign: 'right' }}>
            {(it.stats?.avg?.seconds || 0).toFixed(2)} s
          </td>
          <td style={{ ...cellStyle, background: p10color, textAlign: 'right' }}>
            {p10}
          </td>
          <td style={{ ...cellStyle, background: p50color, textAlign: 'right' }}>
            {p50}
          </td>
          <td style={{ ...cellStyle, background: p90color, textAlign: 'right' }}>
            {p90}
          </td>

          <td style={{ ...cellStyle, width: 80, padding: 0 }}>
            {sl(bytes)}
          </td>
          <td style={{ ...cellStyle, textAlign: 'right' }}>{((it.stats?.avg?.bytes || 0) / 1e3).toFixed(2)}</td>
          <td style={{ ...cellStyle, background: p10bcolor, textAlign: 'right' }}>
            {p10b}
          </td>
          <td style={{ ...cellStyle, background: p50bcolor, textAlign: 'right' }}>
            {p50b}
          </td>
          <td style={{ ...cellStyle, background: p90bcolor, textAlign: 'right' }}>
            {p90b}
          </td>
        </tr>
      )
    });

  return (
    <div>
      <h2>Status</h2>
      {loading && <div>Loading...</div>}

      <table style={{ borderCollapse: 'collapse' }}>
        <thead>
          <th style={{ ...cellStyle, ...stickyStyle }}>case</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>last</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>runtime</th>

          <th style={{ ...cellStyle, ...stickyStyle }}>avg<br />(s)</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>p10<br />(s)</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>p50<br />(s)</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>p90<br />(s)</th>

          <th style={{ ...cellStyle, ...stickyStyle }}>bytes</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>avg<br />(kb)</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>p10<br />(kb)</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>p50<br />(kb)</th>
          <th style={{ ...cellStyle, ...stickyStyle }}>p90<br />(kb)</th>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>

      {/*
      <pre>{JSON.stringify(status, null, 2)}</pre>
      */}

    </div>
  );
}
